import React from 'react';
import { Snackbar, Alert, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';

const TrialOfferSnackbar = ({ open = false, onClose = () => {}, trialToken = null, source = null }) => {
  const navigate = useNavigate();

  const handleView = () => {
    try {
      // Clear stored invite only when user acts on it
      try { sessionStorage.removeItem('trial_invite'); } catch(_) {}
    } catch (_) {}

    // Fire tracking event for click
    try {
      (async () => {
        try { await api.post('/v1/tracking/click', { token: trialToken, source }); } catch (e) { /* ignore */ }
      })();
    } catch (_) {}

    if (trialToken) {
      const params = new URLSearchParams();
      params.set('trialToken', trialToken);
      if (source) params.set('source', source);
      navigate(`/trial-landing?${params.toString()}`);
    } else {
      // Fallback: go to pricing if no token
      navigate('/pricing');
    }
    onClose();
  };

  return (
    <Snackbar
      open={!!open}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      onClose={onClose}
      autoHideDuration={10000}
    >
      <Alert
        onClose={onClose}
        severity="info"
        sx={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        action={(
          <Button color="inherit" size="small" onClick={handleView}>
            View Offer
          </Button>
        )}
      >
        Limited time trial offer — claim it now!
      </Alert>
    </Snackbar>
  );
};

export default TrialOfferSnackbar;
